import { IPagination } from 'app/types/common';

export interface IStripeSessionsState {
  readonly stripeSessionsById?: any;
  readonly stripeSessionIds?: string[];
  readonly hasLoaded?: boolean;
  readonly hasLoaded?: boolean;
  readonly hasSaved?: boolean;
  readonly hasFailed?: boolean;
  readonly isLoading?: boolean;
  readonly isSaving?: boolean;
  readonly selectStripeSessionLoading?: boolean;
  readonly hasLoaded?: boolean;
  readonly showAddStripeSession?: boolean;
  readonly requestedData?: any;
  readonly backendErrors?: any;
  readonly organisationStripeSessionIds?: string[];
  readonly currentStripeSessionId?: string;
  readonly filterConfig?: any;
  readonly sortConfig?: any;
  readonly pagination?: IPagination;
}

export interface IStripeSessionsSelector extends IStripeSessionsState {
  readonly currentStripeSession?: any;
  readonly currentFormStripeSession?: any;
  readonly getStripeSessionsFilteredByTagInSelectFormat?: any;
  readonly stripeSessionsByIdInSelectFormat?: any;
}

export enum StripeSessionsActionTypes {
  GET_ALL_STRIPE_SESSIONS_REQUESTED = 'redux-app/stripe-sessions/GET_ALL_STRIPE_SESSIONS_REQUESTED',
  GET_ALL_STRIPE_SESSIONS_PENDING = 'redux-app/stripe-sessions/GET_ALL_STRIPE_SESSIONS_PENDING',
  GET_ALL_STRIPE_SESSIONS_SUCCESS = 'redux-app/stripe-sessions/GET_ALL_STRIPE_SESSIONS_SUCCESS',
  GET_ALL_STRIPE_SESSIONS_FAIL = 'redux-app/stripe-sessions/GET_ALL_STRIPE_SESSIONS_FAIL',
  GET_STRIPE_SESSION_REQUESTED = 'redux-app/stripe-sessions/GET_STRIPE_SESSION_REQUESTED',
  GET_STRIPE_SESSION_PENDING = 'redux-app/stripe-sessions/GET_STRIPE_SESSION_PENDING',
  GET_STRIPE_SESSION_SUCCESS = 'redux-app/stripe-sessions/GET_STRIPE_SESSION_SUCCESS',
  GET_STRIPE_SESSION_FAIL = 'redux-app/stripe-sessions/GET_STRIPE_SESSION_FAIL',
  UPDATE_STRIPE_SESSION_REQUESTED = 'redux-app/stripe-sessions/UPDATE_STRIPE_SESSION_REQUESTED',
  UPDATE_STRIPE_SESSION_PENDING = 'redux-app/stripe-sessions/UPDATE_STRIPE_SESSION_PENDING',
  UPDATE_STRIPE_SESSION_SUCCESS = 'redux-app/stripe-sessions/UPDATE_STRIPE_SESSION_SUCCESS',
  UPDATE_STRIPE_SESSION_FAIL = 'redux-app/stripe-sessions/UPDATE_STRIPE_SESSION_FAIL',
  CREATE_STRIPE_SESSION_REQUESTED = 'redux-app/stripe-sessions/CREATE_STRIPE_SESSION_REQUESTED',
  CREATE_STRIPE_SESSION_PENDING = 'redux-app/stripe-sessions/CREATE_STRIPE_SESSION_PENDING',
  CREATE_STRIPE_SESSION_SUCCESS = 'redux-app/stripe-sessions/CREATE_STRIPE_SESSION_SUCCESS',
  CREATE_STRIPE_SESSION_FAIL = 'redux-app/stripe-sessions/CREATE_STRIPE_SESSION_FAIL',
  DELETE_STRIPE_SESSION_REQUESTED = 'redux-app/stripe-sessions/DELETE_STRIPE_SESSION_REQUESTED',
  DELETE_STRIPE_SESSION_PENDING = 'redux-app/stripe-sessions/DELETE_STRIPE_SESSION_PENDING',
  DELETE_STRIPE_SESSION_SUCCESS = 'redux-app/stripe-sessions/DELETE_STRIPE_SESSION_SUCCESS',
  DELETE_STRIPE_SESSION_FAIL = 'redux-app/stripe-sessions/DELETE_STRIPE_SESSION_FAIL',
  SELECT_STRIPE_SESSION_REQUESTED = 'redux-app/stripe-sessions/SELECT_STRIPE_SESSION_REQUESTED',
}

export default null;
